import i18n from "../../i18n";
import VendorIcon from "images/auth/freelancer-icon.png";
import AgencyIcon from "images/auth/agency-icon.png";

const defaultVendorValues = {
  firstName: "",
  lastName: "",
  resume: "",
  yearsOfExperience: "",
  isWillingToTravel: true,
  isOpenForSecondment: false,
  hasCatToolsExperience: false,
  catTools: [],
  nationalities: [],
  vendorAdditionalInfo: {
    profile: [],
  },
  sampleOfWorks: [],
};

const defaultAgencyValues = {
  companyName: "",
  representativeName: "",
  rateCard: [],
  multiCvs: [],
  companyWebsite: "",
  portfolio: [],
  hasCatToolsExperience: false,
  catTools: [],
};
const steps = [i18n.t("vendorFreelancer"), i18n.t("agencyType")];
const stepsContent = [
  {
    title: "",
    subTitle: "",
    icon: VendorIcon,
  },
  {
    title: "",
    subTitle: "",
    icon: AgencyIcon,
  },
];

export { defaultVendorValues, defaultAgencyValues, steps, stepsContent };

export const statusFreeLancerOptions = [
  { value: "Invoice Paid", label: "Invoice Paid" },
  { value: "Payment Requested", label: "Payment Requested" },
  { value: "Request Payment Sent", label: "Payment Not Requested" },
];

export const statusAgencyOptions = [
  { value: "Invoice Paid", label: "Invoice Paid" },
  { value: "Payment Requested", label: "Payment Requested" },
  { value: "Request Payment Sent", label: "Payment Not Requested" },
  { value: "Pending Finance Approval", label: "Pending Approval" },
  {
    value: "Pending Penalty Finance Approval",
    label: "Reviewing Penalty",
  },

  { value: "Finance Rejected", label: "Finance Rejected" },
];

export const earningsStatusesColorOptions = {
  "Invoice Paid": {
    label: "Invoice Paid",
    variant: "green",
  },

  "Payment Requested": {
    label: "Payment Requested",
    variant: "blue",
  },

  "Request Payment Sent": {
    label: "Payment Not Requested",
    variant: "orange",
  },

  "Pending Finance Approval": {
    label: "Pending Approval",
    variant: "orange",
  },

  "Pending Penalty Finance Approval": {
    label: "Reviewing Penalty",
    variant: "orange",
  },

  "Finance Rejected": {
    label: "Finance Rejected",
    variant: "red",
  },
};
